
import { HistoryHangingIncomingFilterRequest } from "@/domain/entities/HangingIncoming";
import { Vue, Options } from "vue-class-component";
@Options({
  emits: ["filter"]
})
class FilterHistory extends Vue {
  filter = new HistoryHangingIncomingFilterRequest();
  maxDate = new Date();
  get filterDay() {
    return [
      { name: this.$t("dashboard.filterHistoryHanging.day3"), value: "3" },
      { name: this.$t("dashboard.filterHistoryHanging.day4"), value: "4" },
      { name: this.$t("dashboard.filterHistoryHanging.day5"), value: "5" },
      { name: this.$t("dashboard.filterHistoryHanging.day6"), value: "6" },
      { name: this.$t("dashboard.filterHistoryHanging.day7Plus"), value: ">=7" }
    ];
  }
  activeIndexes: string[] = [];
  toggleActive = (value: string) => {
    if (this.activeIndexes.includes(value)) {
      this.activeIndexes = this.activeIndexes.filter((i) => i !== value);
      this.filter.days = [...this.activeIndexes];
    } else {
      this.activeIndexes.push(value);
      this.filter.days = [...this.activeIndexes];
    }
    this.filter.page = 1;
    this.$emit("filter", this.filter);
  };

  onSearch(value: string) {
    this.filter.search = value;
    this.filter.page = 1;
    this.$emit("filter", this.filter);
  }
  clearSearch() {
    this.filter.search = "";
    this.$emit("filter", this.filter);
  }

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryHangingIncomingFilterRequest({
      ...this.filter,
      startDate,
      endDate
    });
    this.filter.page = 1;
    startDate && endDate && this.$emit("filter", this.filter);
  }
}
export default FilterHistory;
